export default __webpack_public_path__ + "e172e48f5d295ca12be6280dac4a31ad.png";